export const PhoneNumberFilter = (phoneNumber: string, options: {
	mask: boolean;
} = {
	mask: true
}) => {
	// Forcing 10 digit for now
	phoneNumber = phoneNumber.length === 11 ? phoneNumber.substring(1) : phoneNumber;

	if(phoneNumber.length === 10) {
		let regexReplace = '($1) $2-$3';
		if(options.mask) {
			regexReplace = '($1) ***-$3';
		}
		return phoneNumber.replace(/[^0-9]/g, '')
			.replace(/(\d{3})(\d{3})(\d{4})/, regexReplace);
	} else if(phoneNumber.length === 11) {
		let regexReplace = '+$1 ($2) $3-$4';
		if(options.mask) {
			regexReplace = '+$1 ($2) ***-$4';
		}
		return phoneNumber.replace(/[^0-9]/g, '')
			.replace(/(\d)(\d{3})(\d{3})(\d{4})/, regexReplace);
	} else {
		// used - https://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
		const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
		if(phoneRegex.test(phoneNumber)) {
			return phoneNumber;
		}
		return 'Unknown Format';
	}
};
